<script>
export default {
  name: 'ItemListProducts',
  props: {
    product: {
      type: Object,
      required: true
    }
  }
}
</script>

<template>
  <tr class="border-b">
    <th scope="row" class="px-4 py-3 font-medium text-gray-900 whitespace-nowrap">
      {{ product.title }}
    </th>
    <td class="px-4 py-3">
      {{ product.description }}
    </td>
    <td class="px-4 py-3">
      {{ product.price }}
    </td>
    <td class="px-4 py-3">
      {{ product.quantity }}
    </td>
    <td class="px-4 py-3">
      {{ product.category.Label }}
    </td>
    <td class="">
      <router-link :to="`/boutique/${product.tag}`" class="mr-5">
        <i class="fa-regular fa-eye"></i>
      </router-link>
      <router-link :to="{ name: 'app_admin_edit_product', params: { id: product.tag } }" class="">
        <i class="fa-solid fa-pen"></i>
      </router-link>
    </td>
  </tr>
</template>

<style scoped>

</style>